import React from 'react';
import styles from './PromotionSection.module.scss'

const PromotionSection = () => {
  return (
    <section className={styles.promotion}>
      <div className={styles.promotionBox}>
        <h2 className={styles.promotionTitle}>Let's enjoy JPYC Prepaid</h2>
        <p className={styles.promotionText}>日本円建プリペイド型トークンのご利用なら、JPYC Appsへ</p>
        <a 
          href='https://app.jpyc.jp/' 
          target='_blank' 
          rel="noopener noreferrer"
          className={styles.promotionButton}
        >
          JPYC Appsはこちら
        </a>
      </div>
    </section>
  )
};

export default PromotionSection;
